module.exports = __webpack_public_path__ + "static/media/dark.b04cdbbf.png";